<template>
  <v-dialog
    v-if="errorDialog.active"
    v-model="errorDialog"
    persistent
    width="40%"
  >
    <v-card class="black--text" color="cardbg">
      <v-card-title class="headline font-weight-bold">
        {{ title }}
      </v-card-title>
      <v-card-text
        class="subtitle-1 font-weight-medium black--text font-regular"
        v-html="msg"
      ></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="mb-2 importantbutton"
          rounded
          depressed
          @click="executeBtnClb"
        >
          {{ buttonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {},
  created() {},
  computed: {
    errorDialog() {
      return this.$store.getters["error/errorDialog"];
    },
    title() {
      let text = this.$t(this.errorDialog.title);
      if (text == this.errorDialog.title) {
        return this.$t("dialogs.error.default.title");
      } else {
        return text;
      }
    },
    msg() {
      let text;
      if (this.errorDialog.params.msg) {
        text = this.$t(this.errorDialog.msg, {
          ...this.errorDialog.params.msg
        });
      } else {
        text = this.$t(this.errorDialog.msg);
      }
      if (text == this.errorDialog.msg) {
        return this.$t("dialogs.error.default.msg");
      } else {
        return text;
      }
    },
    buttonText() {
      let text = this.$t(this.errorDialog.actionBtn);
      if (text == this.errorDialog.actionBtn) {
        return this.$t("dialogs.error.default.btn");
      } else {
        return text;
      }
    }
  },
  methods: {
    executeBtnClb() {
      if (this.errorDialog.actionBtnClb) this.errorDialog.actionBtnClb();
      else this.closeDialog();
    },
    closeDialog() {
      this.$store.commit("error/RESET", {
        root: true
      });
      this.$store.commit("loading/RESET", {
        root: true
      });
    }
  }
};
</script>

<style>
@media only screen and (max-width: 800px) {
  .v-dialog {
    width: 90% !important;
  }
}

@media only screen and (max-width: 600px) {
  .v-dialog {
    width: 80% !important;
  }
}

@media only screen and (max-width: 480px) {
  .v-dialog {
    width: 80% !important;
  }
}

@media only screen and (max-width: 414px) {
  .v-dialog {
    width: 80% !important;
  }
}

@media only screen and (max-width: 412px) {
  .v-dialog {
    width: 80% !important;
  }
}

@media only screen and (max-width: 375px) {
  .v-dialog {
    width: 90% !important;
  }
}

@media only screen and (max-width: 320px) {
  .v-dialog {
    width: 100% !important;
  }
}
</style>
